import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericConfirmationModalModel } from '@bo-client/shared/models/genericConfirmationModal.model';
import { MatTableDataSource } from '@angular/material/table';
import { CreateOrUpdateTmUserDto } from '@bo-client/shared/models/createOrUpdateTmUserDto';
import { InstallerPassModel } from '@bo-client/shared/models/installerPassDto';

@Component({
  selector: 'app-tm-valid-installer-passes-modal',
  templateUrl: './tm-valid-installer-passes-modal.component.html',
  styleUrls: ['./tm-valid-installer-passes-modal.component.scss']
})
export class TmValidInstallerPassesModalComponent implements OnInit {
  public displayedColumns: string[] = ['passes', 'user', 'action'];
  public dataSourceList = new MatTableDataSource<InstallerPassModel>([]);

  constructor(
    public dialogRef: MatDialogRef<TmValidInstallerPassesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: any
  ) {}

  ngOnInit(): void {
    this.dataSourceList = this.inputData.validPassesList;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  newCommissioning(pass: InstallerPassModel) {
    this.dialogRef.close({ pass: pass });
  }
}
